import type { Price } from "@agapi/mlc-core";

export const calculatePercentDiscount = (price: Price) => {
  if (!price.discount) { return 0 };
  return Math.round((price.discount / price.amount) * 100);
};

const currencyFormats: Record<string, { unit: string, unitPosition: 'after' | 'before' }> = {
  SEK: { unit: 'kr', unitPosition: 'after' },
  DKK: { unit: 'kr', unitPosition: 'after' },
  NOK: { unit: 'kr', unitPosition: 'after' },
  EUR: { unit: ' €', unitPosition: 'after' },
  GBP: { unit: ' £', unitPosition: 'after' }
};

export const formatCurrency = (currency: string) => {
  const format = currencyFormats[currency as keyof typeof currencyFormats] || { after: ' kr', before: '' };
  return format;
}
